var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimer2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 38.5,
    viewBox: "0 0 33 38.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M8.887 0h-7.11A1.8 1.8 0 0 0 0 1.81a1.8 1.8 0 0 0 1.777 1.81h7.11a1.8 1.8 0 0 0 1.777-1.81A1.8 1.8 0 0 0 8.887 0z",
    transform: "translate(11.17)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M1.777 10.857a1.8 1.8 0 0 0 1.777-1.81V1.81A1.8 1.8 0 0 0 1.777 0 1.8 1.8 0 0 0 0 1.81v7.238a1.8 1.8 0 0 0 1.777 1.809z",
    transform: "translate(14.725 12.667)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Subtraction 1",
    d: "M3777-1921.929a15.752 15.752 0 0 1-11.358-4.81 16.241 16.241 0 0 1-3.475-5.351 16.489 16.489 0 0 1-1.164-6.558 15.983 15.983 0 0 1 1.39-6.141 16.536 16.536 0 0 1 3.489-5.042 16.266 16.266 0 0 1 5.049-3.413 15.318 15.318 0 0 1 6.069-1.256 15.6 15.6 0 0 1 5.375.95 16 16 0 0 1 4.615 2.632l1.334-1.356a1.77 1.77 0 0 1 1.253-.523 1.721 1.721 0 0 1 1.236.523l.018.018a1.816 1.816 0 0 1 0 2.533l-1.333 1.357a16.39 16.39 0 0 1 2.571 4.682 16.428 16.428 0 0 1 .931 5.469 16.332 16.332 0 0 1-4.679 11.515 15.752 15.752 0 0 1-11.321 4.771zm0-28.953a12.253 12.253 0 0 0-8.8 3.707 12.7 12.7 0 0 0-3.642 8.96 12.7 12.7 0 0 0 3.642 8.959 12.253 12.253 0 0 0 8.8 3.707 12.253 12.253 0 0 0 8.8-3.707 12.7 12.7 0 0 0 3.641-8.959 12.7 12.7 0 0 0-3.641-8.96 12.253 12.253 0 0 0-8.8-3.706z",
    transform: "translate(-3760.5 1959.929)",
    style: {
      stroke: "transparent",
      strokeMiterlimit: 10,
      fill: "#fff"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer2);
export default __webpack_public_path__ + "static/media/timer2.90f05583fb44dc64587c0398dfc30eef.svg";
export { ForwardRef as ReactComponent };